import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserService } from "src/app/iap/services/user.service";
import { AuthenticationService } from "src/app/shared/auth/auth.service";

import { ClaimsTableSubmittedComponent } from "./claims-table-submitted/claims-table-submitted.component";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-submitted-requests",
    templateUrl: "./submitted-requests.component.html",
    styleUrls: ["./submitted-requests.component.scss"],
    imports: [
        MatCardModule,
        ClaimsTableSubmittedComponent,
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
    ]
})
export class RequestsSubmittedComponent implements OnInit {
  public agencyID: string;

  @ViewChild(ClaimsTableSubmittedComponent)
  private claimsTableSubmittedComponent: ClaimsTableSubmittedComponent;

  @Input() tabParentEvent;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthenticationService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // add guard to not display the Commissions screen if you are not an agent or commissions user
    if (
      this.authService.isAgencyAdmin() ||
      this.authService.isCommissionsUser()
    ) {
      let userInfo = this.authService.getUserInfo();

      this.userService.getAgentByOID(userInfo.oid).subscribe(result => {
        this.agencyID = result;

        // previous line commented and next one uncommented when running locally
        //this.agencyID = result.agencyID;
      });
    }
  }

  refresh(tabParentValue: any) {
    if (tabParentValue) {
      this.claimsTableSubmittedComponent.term0 = tabParentValue.term0;
      this.claimsTableSubmittedComponent.term1 = tabParentValue.term1;
    }

    this.claimsTableSubmittedComponent.refreshData(tabParentValue);
  }

  getSelectedTerm(): any {
    return this.claimsTableSubmittedComponent.selectedTermOption;
  }

  onDispute(id: string): void {
    let url = "iap/commissions/disputed-request-all/";
    this.router.navigate([url, this.agencyID]);
  }
}
